import { StripeElementsOptions } from '@stripe/stripe-js';

export const stripeApiVersion = '2023-08-16';

/** `code` on the one-page authorize refusal when the card's postal-code check failed. */
export const POSTAL_CODE_MISMATCH = 'postal_code_mismatch';

/**
 * Stripe product tax codes for the membership. A tax code is a product
 * *classification*, not a rate.
 *
 * Stripe has no "lease of tangible personal property" code. Chicago's 15%
 * Personal Property Lease Transaction Tax is only returned by Stripe — with the
 * Chicago `local_lease_tax` registration active — when the line is classed as a
 * lease (a SaaS code), in which case Stripe also auto-exempts sales tax. So we
 * apply the lease code ONLY to Chicago addresses (see getMembershipTaxCode) and
 * leave every other address on the default tangible-goods code, unchanged — no
 * cross-state tax change. These must match the tax codes on the authoritative
 * membership products so the signup estimate and the real charge agree. Confirm
 * the lease classification with finance/tax before production.
 */
export const MEMBERSHIP_TAX_CODE = 'txcd_99999999'; // General - Tangible Goods (default / non-Chicago)
export const MEMBERSHIP_CHICAGO_LEASE_TAX_CODE = 'txcd_10103000'; // classed as a lease -> Chicago 15% lease tax, sales tax exempt

export const stripeOptions: StripeElementsOptions = {
  mode: 'setup', // Note: other possible value is 'payment'
  currency: 'usd'
  // clientSecret: '{{CLIENT_SECRET}}', // passing the client secret obtained from the server
};

export const STRIPE_ELEMENT_OPTIONS = {
  style: {
    base: {
      fontFamily: '"Red Hat Text Normal", Helvetica',
      fontSize: '15px',
      fontWeight: '300',
      color: '#121212',
      '::placeholder': {
        fontFamily: '"Red Hat Text Normal", Helvetica',
        fontSize: '15px',
        fontWeight: '300',
        color: '#c4c4c4'
      }
    },
    invalid: {
      color: '#121212'
    }
  },
  classes: {
    base: 'StripeElement-input'
  }
};
